
    var refs = 0;
    var css = require("!!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].rules[2]!../../../node_modules/postcss-loader/src/index.js??ruleSet[1].rules[1].rules[3]!./Footer.css");
    var css_default = css.default || css;
    var insertCss = require("!../../../node_modules/isomorphic-style-loader/insertCss.js");
    var content = typeof css_default === 'string' ? [[module.id, css_default, '']] : css_default;

    exports = module.exports = css_default.locals || {};
    exports._getContent = function() { return content; };
    exports._getCss = function() { return '' + css_default; };
    exports._insertCss = function(options) { return insertCss(content, options) };

    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (module.hot && typeof window !== 'undefined' && window.document) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].rules[2]!../../../node_modules/postcss-loader/src/index.js??ruleSet[1].rules[1].rules[3]!./Footer.css", function() {
        css = require("!!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].rules[2]!../../../node_modules/postcss-loader/src/index.js??ruleSet[1].rules[1].rules[3]!./Footer.css");
        content = typeof css === 'string' ? [[module.id, css, '']] : css;
        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  